import { useMemo, useCallback } from 'react';
import { useAuthStore } from '../store/useAuthStore';
import { useAppInstallModal } from '../store/useAppInstallModal';
import { isIOS, isAndroid } from '../util/navigator';
import { openAppAndAction } from '../util/util';

/**
 * 업로드 접근 가드 훅
 * - canUpload: 데스크톱이고 업로드 권한이 있는지 여부
 * - guardUploadClick: 클릭 가드 (허용 시 onAllowed 실행, 불가 시 팝업)
 */
export function useUploadGuard(userAgent) {
  const { isLogin, user } = useAuthStore();
  const { openModal } = useAppInstallModal();

  const isMobile = useMemo(() => isIOS(userAgent) || isAndroid(userAgent), [userAgent]);

  const canUpload = useMemo(() => {
    if (!isLogin || !user || !user.seller) return false;
    const { seller } = user;
    return Boolean(seller.is_certified || seller.is_tester || user.isBusiness);
  }, [isLogin, user]);

  const showMobilePopup = useCallback(() => {
    openAppAndAction(() => openModal('판매는 앱에서!\n수수료는 영원히 0원'), null, 1000);
  }, [openModal]);

  const showBlockedPopup = useCallback(() => {
    openAppAndAction(() => openModal('판매는 앱에서!\n수수료 없이 간편하게 시작하세요'), null, 1000);
  }, [openModal]);

  const guardUploadClick = useCallback((e, { onAllowed } = {}) => {
    if (isMobile) {
      if (e && typeof e.preventDefault === 'function') e.preventDefault();
      showMobilePopup();
      return;
    }
    if (!canUpload) {
      if (e && typeof e.preventDefault === 'function') e.preventDefault();
      showBlockedPopup();
      return;
    }
    if (typeof onAllowed === 'function') onAllowed();
  }, [isMobile, canUpload, showMobilePopup, showBlockedPopup]);

  return { canUpload, isMobile, guardUploadClick };
}
